import styled from 'styled-components'

const Paragraph = styled.p`
  margin: 0 0 40px;
`

export default Paragraph
